interface CheckoutEntry {
  message: string;
}

const stack: CheckoutEntry[] = [];
const listeners = new Set<() => void>();

const notify = () => listeners.forEach((l) => l());

export const beginCheckout = (message: string) => {
  stack.push({ message });
  notify();
};

export const endCheckout = () => {
  if (stack.length === 0) return;
  stack.pop();
  notify();
};

export const isCheckoutInProgress = () => stack.length > 0;

export const getCheckoutMessage = (): string =>
  stack.length > 0 ? stack[stack.length - 1].message : '';

export const subscribeCheckoutInProgress = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
